/*
 * Trägolv (SWISS) image-banner visibility toggle on the product page media gallery.
 * Moved out of snippets/clearance-ui.liquid and snippets/reduced-ui.liquid, where it
 * was inlined on every render (3 copies per product card on collection pages).
 * Only does anything when both .tragolv-image-banner and .media-gallery exist.
 */
(function () {
  if (window.__kgTragolvBannerLoaded) return;
  window.__kgTragolvBannerLoaded = true;

document.addEventListener('DOMContentLoaded', function() {
  const banner = document.querySelector('.tragolv-image-banner');
  const gallery = document.querySelector('.media-gallery');
  if (!banner || !gallery) return;

  function getActiveItem() {
    const items = gallery.querySelectorAll('.media-viewer__item');
    let active = null;
    let minOffset = Infinity;
    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      const offset = Math.abs(rect.left);
      if (offset < minOffset && rect.width > 0) {
        minOffset = offset;
        active = item;
      }
    });
    return active;
  }

  function isVideoItem(item) {
    if (!item) return false;
    return (
      item.dataset.mediaType === 'external_video' ||
      item.dataset.mediaType === 'video' ||
      !!item.querySelector('deferred-media') ||
      !!item.querySelector('iframe') ||
      !!item.querySelector('.js-load-media')
    );
  }

  function toggleBannerVisibility() {
    const active = getActiveItem();
    if (!active) return;
    const isVideo = isVideoItem(active);
    banner.style.transition = 'opacity 0.3s ease';
    banner.style.opacity = isVideo ? '0' : '1';
    banner.style.pointerEvents = isVideo ? 'none' : 'auto';
  }

  function delayedToggle() {
    setTimeout(toggleBannerVisibility, 700);
  }

  // Init
  toggleBannerVisibility();

  gallery.addEventListener('click', e => {
    delayedToggle();
    // Om det är en video-knapp (Shopifys deferred-media)
    if (e.target.closest('.js-load-media')) {
      setTimeout(toggleBannerVisibility, 1000);
    }
  });

  document.addEventListener('mediaGallery:change', delayedToggle);
  document.addEventListener('shopify:section:load', toggleBannerVisibility);

  const observer = new MutationObserver(delayedToggle);
  observer.observe(gallery, { subtree: true, attributes: true, childList: true });

  window.addEventListener('scroll', delayedToggle);
});
})();
